"use client"

import { cn } from "src/utils/Functions"
import { Briefcase, Check, X, Plus } from "lucide-react"
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/menu"
import { usePortfolio } from "@/contexts/PortfolioContext"

export function NavPortfolio() {
  const { entities, activeEntityId: activeId, setActiveEntityId: setActiveId, activeEntity, openCreateDialog } = usePortfolio()

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger render={(
            <SidebarMenuButton
              size="default"
              className={cn(
                "group/portfolio gap-2",
                activeEntity ? activeEntity.bgClass : ""
              )}
            >
              {activeEntity ? (
                <>
                  {activeEntity.image ? (
                    <img src={activeEntity.image} alt="" className="size-4 shrink-0 rounded-full object-cover" />
                  ) : (
                    <activeEntity.icon className={cn("size-4 shrink-0", activeEntity.color)} />
                  )}
                  <span className={cn("truncate text-sm font-medium", activeEntity.color)}>
                    {activeEntity.name}
                  </span>
                </>
              ) : (
                <>
                  <Briefcase className="size-4 shrink-0 text-muted-foreground" />
                  <span className="truncate text-sm text-muted-foreground">All Portfolios</span>
                </>
              )}
            </SidebarMenuButton>
          )} />
          <DropdownMenuContent
            className="min-w-48 rounded-lg z-9999"
            side="top"
            align="start"
            sideOffset={4}
          >
            {entities.map((entity) => {
              const isActive = activeId === entity.id
              return (
                <DropdownMenuItem
                  key={entity.id}
                  className="gap-2"
                  onClick={() => setActiveId(isActive ? null : entity.id)}
                >
                  {entity.image ? (
                    <img src={entity.image} alt="" className="size-4 rounded-full object-cover" />
                  ) : (
                    <entity.icon className={cn("size-4", isActive ? entity.color : "text-muted-foreground")} />
                  )}
                  <span className={cn("flex-1", isActive && "font-medium")}>{entity.name}</span>
                  {isActive && <Check className={cn("size-3.5", entity.color)} />}
                </DropdownMenuItem>
              )
            })}
            {activeEntity && (
              <>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  className="gap-2 text-muted-foreground"
                  onClick={() => setActiveId(null)}
                >
                  <X className="size-4" />
                  <span>Clear selection</span>
                </DropdownMenuItem>
              </>
            )}
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="gap-2 text-muted-foreground"
              onClick={openCreateDialog}
            >
              <Plus className="size-4" />
              <span>New Portfolio</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
